import React, {useState, useEffect, useRef } from 'react';
import { useLocation, useParams} from 'react-router-dom';
import { useProdottoCompleto } from '../../../components/hooks/hooks-e-commerce/useProdotti';
import { useSmoothScroll } from '../../../components/hooks/useSmoothscroll'
import { useConfirmToast } from '../../modules/ConfirmToast';
import SelezioneConfezioni from '../../modules/SelezioneConfezioni';
import Scatolla from '../../../components/images/icons/iconOrDelPackagingW80.png';
import Pagamento from '../../../components/images/icons/iconOrPagSecuroW103.png';
import Delivery from '../../../components/images/icons/iconOrDeliveryW80.png';
import './schedatecnicavini.scss';

function SchedaTecnicaVini() {
    const { id } = useParams(); // id sarà la stringa "1" dall'URL
    const pointScroll = useRef(null);
    const location = useLocation();
    const productId = parseInt(id, 10);
    const {prodotto, loading, error} = useProdottoCompleto(productId);
    const { showConfirm, ConfirmToastComponent } = useConfirmToast();
    const { scrollTo } = useSmoothScroll();

    console.log('in Scheda tecnica per vini: ', prodotto);

    const cartObject = prodotto ? {
        idProdotto: productId,
        nome_vino: prodotto.nome_vino,
        vigneta: prodotto.immagini.imgcart,
        promo: prodotto.promo_attiva,
        promoValue: prodotto.promo_value,
        prezzo: prodotto.prezzo,
    } : null; 

    const [time, setTime] = useState({
            data: new Date(),
            options: {'weekday': 'long', 'year': 'numeric', 'month': 'long', 'day': 'numeric'}
            //options: { 'month': 'short', 'year': 'numeric'}
        });

    function setDelivery() {
        let date = new Date(); 
        const map = {
            mm: date.getMonth(),
            dd: date.getDate() + 2,
            yyyy: date.getFullYear()
        }
        return setTime({data:new Date(Date.UTC(map.yyyy, map.mm, map.dd, 3, 0, 0 ))})
    }

    useEffect(() => {
        if (!loading && prodotto && location.state?.scrollToSection && pointScroll.current) {
            const offset = 220; 
            const topPosition =
                pointScroll.current.getBoundingClientRect().top +
                window.scrollY -
                offset;

            setTimeout(() => {
                scrollTo(topPosition, 1500); // durée 1,5s, easing par défaut
            }, 200); 
        }
    }, [loading, prodotto, location, scrollTo]);

    useEffect(() => {
        setDelivery();
    }, []); 
    
        // Funzione che viene chiamata dal pulsante per chiedere conferma
    const handleConfirmRequired = async (nomeProdotto) => {
        const confirmed = await showConfirm(
            `Aggiungere ${nomeProdotto} al carrello?`
        );
        return confirmed;
    };

    if (loading) return <div>Caricamento...</div>;
    if (error) return <div>Errore: {error}</div>;
    if (!prodotto) return <div>Prodotto non trovato</div>;

    return(
        <section>
            <div className="container-articolo">
                <div className="articolo__identita">
                    <p>{prodotto.nome_cantina}</p>
                    <div className="linea-orizontale"></div>
                    <p>{prodotto.nome_vino} - {prodotto.tipo_vino}</p>
                    <p>{prodotto.denominazione} - {prodotto.annata}{/*  - {prodotto.provincia} */}</p>
                    <p>{prodotto.descrizione_intro}</p> 
                </div>
                <div className="container-scheda__tecnica">
                    <div className='scheda__illustrat' >
                        <img src={require(`../../components/images/catalogo/${prodotto.immagini_scheda.imgscheda}.png`)} alt="Bottle of wine" />
                    </div>
                    
                    <div className='scheda-tecnica__info'>
                        <ul>
                            <li><p>Temperatura di servicio</p> <p>{prodotto.temperatura_servizio}</p></li>
                            <li><p>Capacità di invecchiamento</p> <p>{prodotto.invecchiamento}</p></li>
                            <li><p>Bottigle</p> <p>{prodotto.contenuto_ml}</p></li>
                            <li><p>Prima annata di produzione</p> <p>{prodotto.prima_annata}</p></li>
                            <li><p>Natura del terreno</p> <p>{prodotto.terreno}</p></li>
                            <li><p>Anno di impianto dei vigneti</p> <p>{prodotto.aspeti_organolettici.annoImpianto}</p></li>
                            <li><p>Sistema di allevamento</p> <p>{prodotto.systema_allev}</p></li>
                            <li><p>Tipo di coltivazione</p> <p>{prodotto.tipo_coltivazione}</p></li>
                            <li><p>Epoca di vendimmia</p> <p>{prodotto.vendimmia}</p></li> 
                        </ul>
                    </div>   
                    
                    <div className='scheda-tecnica__info'>    
                        <ul>
                            <li><p>Varieta delle uve</p> <p>{prodotto.varieta_uve} </p> </li>
                            <li><p>Resa in vino</p> <p>{prodotto.resa} </p> </li>
                            <li><p>Vinificazione</p> <p>{prodotto.vinificazione} </p> </li>
                            <li><p>Affinamento</p> <p>{prodotto.affinamento} </p> </li>
                            <li><p>Area di produzione</p> <p>{prodotto.area_prod}</p> </li>
                            <li><p>Densita di impianto</p> <p>{prodotto.densita_impianto}</p> </li> 
                        </ul>
                    </div>
                </div>

                <div className="container-delevery__infos" ref={pointScroll}>
                    {prodotto.promo_attiva ? (<div className="delevery-card__prezzo">
                        <p>Prezzo all'unita : € {prodotto.prezzo}</p>
                        <p><i>Prodotto con uno sconto del {prodotto.promo_value} % </i></p>
                        <p style={{fontWeight: "bold"}} >Prodotto venduto solo in confezioni da 3, 6 o 12 unità</p>
                    </div>) : (
                    <div className="delevery-card__prezzo">
                        <p>Prezzo all'unita : € {prodotto.prezzo}</p>
                        <p style={{fontWeight: "bold"}} >Prodotto venduto solo in confezioni da 3, 6 o 12 unità</p>
                    </div>)}
                    
                    {/*{prodotto.promo ? <div className="delevery-card__premi">
                        <img src={require(`../../components/images/iconstore/${prodotto.immagini.iconDenon}.png`)} alt="icon denomination of wine" />
                    </div> :
                    <div className="delevery-card__premi">
                        <img src={require(`../../components/images/iconstore/${prodotto.immagini.iconDenon}.png`)} alt="icon denomination of wine" />
                    </div> }*/}
                </div>

                <div className="scheda-add__cart">
                <SelezioneConfezioni 
                    cartObject={cartObject}
                    onConfirmRequired={handleConfirmRequired}    
                />
                </div>
                <div className="delivery__condition">
                    <div className="delivery__infos">
                        <img src={Scatolla} alt="icon packaging" />
                        <p>Imballaggi rinforzati</p>
                    </div>

                    <div className="delivery__infos">
                        <img src={Delivery} alt="icon delivery" />
                        <p>Consegnato il:  <span>{time.data.toLocaleDateString('it-IT', time.options)}</span></p>
                    </div>
                        
                    <div className="delivery__infos">
                    <img src={Pagamento} alt="icon payment" />
                        <p>Pagamento sicuro</p>
                    </div>
                </div>
            </div>
            <ConfirmToastComponent/>
        </section>
    )
}
export default SchedaTecnicaVini
